import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL = `${BaseUrl}product`;

export const getProducts = () => axios.get(`${API_URL}/list-product`);

export const getProductById = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/${id}`, {
        headers: {
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}
export const searchProduct = (param) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/search-product/${param}`, {
        headers: {
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        }, searchProduct
    });
}
export const getProductByFilter = (filters = {}) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/product/filter-product`, {
        headers: {
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
        params: filters
    });
}

export const filterProduct = (param) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/product/filter-product`, {

        params: param,
        headers: {
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const productSearchCategory = (param) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/product/search-product-category${param}`, {
        headers: {
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}
export const productSearchType = (param) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL}/product/search-product-type${param}`, {
        headers: {
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}
export const countCategories = () => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/product/count-category`, {
        headers: {
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}

export const countType = () => {
    const token = localStorage.getItem('token');
    return axios.get(`${API_URL}/product/count-types`, {
        headers: {
            'Content-Type': 'application/json',  // Indicates the format of the request data
            'Accept': 'application/json',
            Authorization: `Bearer ${token}`, // Send token in Authorization header
        },
    });
}